import ParseHtml from '@components/Custom/ParseHtml';
import Box from '@mui/material/Box';
import { isDefined } from '../../config/helpers';
import useWindowSize from '../../_hooks/useWindowSize'

const CategoryLongDescription = ({isMobile, long_desc, layout}) => {
    const screensize = useWindowSize();
    return (
        <Box
            className={"p-2 mt-2 " + ((layout == 'box' && screensize.width > 1200 ) || (!isDefined(screensize.width) && !isMobile) ? 'f-size_3' : 'f-size_1')}
            sx={{
                '& .MuiTypography-p': {
                    fontSize: 16
                }
            }}
        >
            <ParseHtml html={long_desc}/>
        </Box>

    )
}

export default CategoryLongDescription